import { StanDropdownMenu } from '@/components';
import { DropdownProvider } from '@/components/core-components/StanDropdown/DropdownProvider';
import type { FunnelListItem } from '../../types';
import { useAddFunnelToStore } from '../../hooks/useAddFunnelToStore';
import IcEdit from '@/assets/icons/ic-edit-01.svg';
import IcDuplicate from '@/assets/icons/ic-duplicate.svg';
import IcTrash from '@/assets/icons/ic-trash.svg';
import IcMoreVertical from '@/assets/icons/ic-more-vertical.svg';
import IcFunnel from '@/assets/icons/ic-funnel.svg';

interface FunnelActionsMenuProps {
    funnel: FunnelListItem;
    onEdit: (funnel: FunnelListItem) => void;
    onDuplicate: (funnel: FunnelListItem) => void;
    onDelete: (funnel: FunnelListItem) => void;
}

const FUNNEL_ACTION_OPTIONS = [
    {
        label: 'Edit Details',
        value: 'edit',
        icon: IcEdit,
    },
    {
        label: 'Add to My Store',
        value: 'add-to-store',
        icon: IcFunnel,
    },
    {
        label: 'Duplicate',
        value: 'duplicate',
        icon: IcDuplicate,
    },
    {
        label: 'Delete',
        value: 'delete',
        icon: IcTrash,
        type: 'destructive' as const,
    },
];

/**
 * Dropdown actions menu for each funnel row.
 * Matches Vue AppDropdownMenu options from funnels_list.vue.
 */
export const FunnelActionsMenu = ({ funnel, onEdit, onDuplicate, onDelete }: FunnelActionsMenuProps) => {
    const addToStore = useAddFunnelToStore();

    const handleSelect = (option: { value: string | number }) => {
        switch (option.value) {
            case 'edit':
                onEdit(funnel);
                break;
            case 'add-to-store':
                addToStore({
                    storeId: funnel.store_id,
                    slug: funnel.slug,
                    name: funnel.name,
                    url: funnel.url,
                });
                break;
            case 'duplicate':
                onDuplicate(funnel);
                break;
            case 'delete':
                onDelete(funnel);
                break;
        }
    };

    return (
        <DropdownProvider
            dropdownId={`funnel-actions-${funnel.store_id}`}
            dropdownName={`funnel-actions-${funnel.store_id}`}
        >
            <StanDropdownMenu
                id={`funnel-actions-${funnel.store_id}`}
                name={`funnel-actions-${funnel.store_id}`}
                options={FUNNEL_ACTION_OPTIONS}
                onSelect={handleSelect}
                placement='bottom-end'
                minWidth={180}
            >
                <IcMoreVertical className='text-semantic-fg-muted size-5' />
            </StanDropdownMenu>
        </DropdownProvider>
    );
};
